/**
 * Vietnamese.
 *
 * Fully translated. "Followers", "likes" and "views" are kept where Vietnamese
 * social media keeps them — "lượt thích" and "lượt xem" are standard and used
 * here, while "follower" is more common than "người theo dõi" in this market
 * and appears alongside it. Addressed as "bạn", the register a shop uses.
 */
export default {
  nav: {
    home: 'Trang chủ',
    services: 'Dịch vụ',
    faq: 'Câu hỏi thường gặp',
    help: 'Trợ giúp',
    signIn: 'Đăng nhập',
    getStarted: 'Bắt đầu',
    openPanel: 'Mở bảng điều khiển',
    language: 'Ngôn ngữ',
    currency: 'Tiền tệ',
  },

  common: {
    perThousand: 'mỗi 1.000',
    from: 'Từ {amount} mỗi 1.000',
    noSubscription: 'Không thuê bao',
    neverPassword: 'Không bao giờ hỏi mật khẩu',
    cancel: 'Huỷ',
    done: 'Xong',
    total: 'Tổng cộng',
    rate: 'Đơn giá',
    range: 'Khoảng',
    starts: 'Bắt đầu',
    refill: 'Bù hao',
    quantity: 'Số lượng',
    lowest: 'thấp nhất',
    services: 'dịch vụ',
    platforms: 'nền tảng',
    shownIn: 'Hiển thị bằng {display} theo tỷ giá hôm nay · thanh toán bằng {platform}',
    chargedIn: 'Thanh toán bằng {code}',
    cancelWhilePending: 'khi đơn còn đang chờ',
    notOffered: 'không hỗ trợ',
    chargedAs: 'thanh toán là {amount}',
  },

  home: {
    refresh: {
      titleA: 'Dịch vụ mạng xã hội.',
      titleB: 'Giá rõ ràng. Đơn hàng theo dõi được.',
      lede: 'Xem các dịch vụ follower, lượt thích và lượt xem cho TikTok, Instagram và YouTube. Kiểm tra giá, thời gian giao dự kiến và điều kiện bù hao trước khi đặt đơn.',
      eyebrowIdle: 'Khám phá dịch vụ của chúng tôi',
      demo: 'Minh họa theo dõi đơn',
      demoNote: 'Đơn ví dụ · hoạt ảnh chạy ở tốc độ 60×',
      servicesKey: 'Khám phá danh mục',
      servicesTitle: 'Tìm dịch vụ phù hợp.',
      servicesBody: 'So sánh giá hiện tại và điều khoản dịch vụ trước khi tạo tài khoản. Thời gian bắt đầu chỉ là ước tính, không phải cam kết hoàn thành.',
      perThousand: 'mỗi 1.000',
      minimum: 'Số lượng tối thiểu',
      start: 'Bắt đầu dự kiến',
      notListed: 'Không ghi',
      refill: 'Bảo hành bù hao',
      days: '{count} ngày',
      seeTerms: 'Xem điều khoản dịch vụ',
      details: 'Xem chi tiết dịch vụ',
      loading: 'Đang tải dịch vụ hiện có…',
      empty: 'Hiện chưa có dịch vụ nào để xem trước. Hãy xem danh mục để biết dịch vụ đang có.',
      currencyNote: 'Giá quy đổi chỉ là ước tính. Hãy kiểm tra loại tiền thanh toán và tổng cuối cùng trước khi trả tiền.',
      faqKey: 'Trước khi đặt đơn',
      faqTitle: 'Biết trước điều cần chờ đợi.',
      moreAnswers: 'Thêm câu hỏi thường gặp',
      closingTitle: 'Tìm dịch vụ đầu tiên của bạn.',
      closingBody: 'So sánh giá và điều khoản. Chọn số lượng khi bạn sẵn sàng.',
      steps: {
        chooseTitle: 'Chọn dịch vụ',
        chooseBody: 'Duyệt theo nền tảng và so sánh giá, số lượng tối thiểu và bảo hành bù hao.',
        reviewTitle: 'Kiểm tra chi tiết',
        reviewBody: 'Nhập liên kết công khai và số lượng. Kiểm tra tổng tiền, thời gian giao dự kiến và điều kiện dịch vụ trước khi xác nhận.',
        trackTitle: 'Theo dõi đơn hàng',
        trackBody: 'Theo dõi trạng thái được báo cáo trong tài khoản của bạn. Liên hệ hỗ trợ nếu đơn bị đứng hoặc kết quả cần được xem lại.',
      },
      faq: {
        deliveryTitle: 'Giao hàng mất bao lâu?',
        deliveryBody: 'Thời gian tùy theo dịch vụ và số lượng. Thời gian bắt đầu dự kiến cho biết khi nào việc giao có thể bắt đầu, không phải khi nào hoàn thành. Có thể xảy ra chậm trễ; hãy liên hệ hỗ trợ nếu đơn của bạn vượt quá thời gian dự kiến.',
        dropsTitle: 'Follower hoặc các chỉ số khác có thể bị tụt không?',
        dropsBody: 'Có. Chỉ số có thể giảm sau khi giao. Chỉ những dịch vụ có bảo hành bù hao mới được bù, trong thời hạn và điều kiện đã nêu. Dịch vụ không có bù hao không bao gồm việc bù.',
        refundsTitle: 'Tiền hoàn về đâu?',
        refundsBody: 'Khi đơn được xác nhận là đã hủy hoặc giao một phần, số tiền đủ điều kiện của phần chưa giao sẽ được hoàn vào ví PresenceRise của bạn. Đây là tín dụng tài khoản, không phải hoàn tiền về thẻ. Đơn đang xử lý không tự động được hoàn tiền chỉ vì bị chậm.',
        passwordTitle: 'Tôi có cần cung cấp mật khẩu mạng xã hội không?',
        passwordBody: 'Không. Đơn hàng dùng liên kết hồ sơ hoặc bài viết công khai của bạn. Đừng bao giờ ghi mật khẩu hoặc mã đăng nhập vào đơn hàng hay tin nhắn hỗ trợ.',
        paymentsTitle: 'Tôi có thể dùng những phương thức thanh toán nào?',
        paymentsBody: 'Các phương thức khả dụng hiển thị khi thanh toán hoặc khi nạp tiền. Chúng có thể khác nhau theo quốc gia và loại tiền. Hãy kiểm tra các lựa chọn và mọi khoản phí trước khi thanh toán.',
      },
    },
    eyebrow: '{count} dịch vụ đang hoạt động trên {platforms} nền tảng',
    eyebrowIdle: 'Đang nhận đơn',
    titleA: 'Tăng trưởng bạn',
    titleB: 'nhìn thấy được.',
    lede: 'Follower, lượt thích, lượt xem và người đăng ký, tính giá theo nghìn và giao qua một quy trình bạn nhìn thấy được. Mọi đơn đều được theo dõi trực tiếp, đo lại sau khi xong, và tự hoàn tiền hoặc bù hao khi giao thiếu.',
    ctaStart: 'Bắt đầu miễn phí',
    ctaBrowse: 'Xem dịch vụ',
    ctaOrder: 'Đặt đơn',
    delivering: 'Đang giao {count} đơn',
    illustration: 'Minh hoạ, chạy nhanh 60 lần',
    figures: {
      services: 'dịch vụ',
      platforms: 'nền tảng',
      from: 'từ, mỗi 1.000',
      refill: 'có thời hạn bù hao',
      remeasured: 'ngày mỗi đơn được đo lại',
      tickets: 'phiếu cần mở để được hoàn tiền',
    },
    life: {
      key: 'Vòng đời của một đơn hàng',
      title: 'Sáu việc xảy ra với mọi đơn hàng. Không việc nào cần bạn làm.',
      pricedTitle: 'Tính giá trên máy chủ',
      pricedBody:
        'Số lượng của bạn được tính bằng chính đoạn mã mà API dùng. Con số bạn duyệt là con số bị trừ.',
      chargedTitle: 'Chỉ trừ một lần',
      chargedBody: 'Ví của bạn bị trừ ngay khi đơn được tạo, và không bao giờ bị trừ lại cho đơn đó.',
      sentTitle: 'Đã gửi và đang theo dõi',
      sentBody:
        'Định tuyến tới nhà cung cấp giữ đơn tốt nhất cho dịch vụ đó, rồi theo dõi cho tới khi hoàn tất.',
      deliveringTitle: 'Đang giao',
      deliveringBody:
        'Xem trên biểu đồ Climb: bạn bắt đầu ở đâu, đang ở đâu, và sẽ tới đâu với tốc độ hiện tại.',
      measuredTitle: 'Đo lại ở 1, 7 và 30 ngày',
      measuredBody: 'Số đã giao được đọc lại và so với lúc hoàn tất. Tỷ lệ còn lại được công bố.',
      settledTitle: 'Tự bù hao hoặc hoàn tiền',
      settledBody:
        'Sụt giảm trong thời hạn bù hao sẽ tự động gửi yêu cầu bù. Đơn giao thiếu sẽ hoàn phần chênh lệch về ví của bạn.',
    },
    kept: {
      key: 'Vì sao chúng tôi không rẻ nhất',
      title: 'Follower rẻ nhất là follower ở lại.',
      body: 'Giá thấp hơn nhưng mất một phần ba lượng đã giao thì đắt hơn nếu tính trên mỗi follower bạn giữ được, so với giá cao hơn nhưng ở lại. Mọi đơn được định tuyến theo giá trên mỗi đơn vị còn lại, không theo giá niêm yết, và con số giữ chân đứng sau quyết định đó được in ngay trên dịch vụ để bạn kiểm tra.',
      link: 'Câu trả lời đầy đủ, trong phần Câu hỏi thường gặp',
      sticker: 'Giá niêm yết',
      held: 'Còn lại sau 30 ngày',
      effective: 'Mỗi 1.000 giữ được',
      cheaper: 'Lựa chọn rẻ hơn',
      ours: 'Lựa chọn chúng tôi định tuyến',
      foot: 'Số liệu minh hoạ. Số liệu thật nằm trên từng dịch vụ, kèm cỡ mẫu.',
    },
    steps: {
      fundsTitle: 'Nạp tiền',
      fundsBody: 'Thẻ, hoặc GCash, Maya và GrabPay tại Philippines. Không thuê bao.',
      pickTitle: 'Chọn dịch vụ',
      pickBody: 'Chọn kết quả bạn muốn, dán liên kết công khai, xem tổng chính xác trước khi xác nhận.',
      watchTitle: 'Xem nó đi lên',
      watchBody: 'Việc giao được theo dõi trực tiếp. Giao thiếu tự hoàn tiền; sụt giảm tự bù hao.',
    },
    cta: {
      title: 'Sẵn sàng khi bạn sẵn sàng.',
      body: 'Không thuê bao, không mức chi tối thiểu, không bao giờ hỏi mật khẩu.',
      account: 'Tạo tài khoản',
    },
  },

  services: {
    key: 'Dịch vụ',
    titleA: 'Mọi dịch vụ,',
    titleB: 'mọi mức giá.',
    lede: 'Một trục giá được hiệu chỉnh cho mỗi loại kết quả, nên độ phân tán của các vạch chính là thị trường. Mọi mức giá tính theo 1.000 đơn vị, không phát sinh khi thanh toán. Nhấp vào một hàng để tính giá cho số lượng thật.',
    quality: 'Chất lượng',
    region: 'Khu vực',
    anyQuality: 'Mọi chất lượng',
    anyRegion: 'Mọi khu vực',
    allPlatforms: 'Tất cả nền tảng',
    search: 'Tìm dịch vụ',
    refillOnly: 'Chỉ loại có bù hao',
    sort: 'Sắp xếp',
    sortPrice: 'Giá',
    sortRetention: 'Giữ chân',
    sortName: 'Tên',
    empty: 'Không có dịch vụ phù hợp',
    emptyBody: 'Thử từ khoá khác hoặc xoá bộ lọc.',
    showEverything: 'Hiện tất cả',
    priceIt: 'Tính giá',
    priceEmpty:
      'Nhấp vào bất kỳ hàng nào và giá cho số lượng thật sẽ hiện ở đây — đúng bằng con số mà trang đặt đơn sẽ tính.',
    order: 'Đặt dịch vụ này',
    orderGuest: 'Tạo tài khoản để đặt đơn',
    includes: 'Giá này gồm những gì',
    terms: {
      perThousandTitle: 'Giá tính theo 1.000 đơn vị',
      perThousandBody:
        'Mọi dịch vụ đều báo giá theo cùng một cách, nên so sánh được trực tiếp. Giá $1.23 mua 1.000; 500 chỉ bằng một nửa.',
      totalTitle: 'Tổng được tính trước khi bạn xác nhận',
      totalBody:
        'Số lượng của bạn được tính trên máy chủ của chúng tôi và hiện đầy đủ. Con số bạn duyệt là con số bị trừ — không phát sinh khi thanh toán.',
      balanceTitle: 'Bạn nạp số dư, không phải đăng ký thuê bao',
      balanceBody: 'Nạp tiền khi cần và chi từ số dư đó. Không trừ định kỳ, không mức tối thiểu hàng tháng.',
      refundTitle: 'Đơn giao thiếu được hoàn tự động',
      refundBody:
        'Nếu đơn giao không đủ, phần chưa giao sẽ tự quay lại số dư của bạn. Bạn không cần để ý hay mở phiếu hỗ trợ.',
      refillTitle: 'Nhiều dịch vụ có thời hạn bù hao',
      refillBody:
        'Dịch vụ nào có bù hao thì thời hạn được ghi ngay trên hàng, và chúng tôi sẽ gửi yêu cầu bù khi kiểm tra thấy sụt giảm.',
    },
  },

  auth: {
    signInKey: 'Đăng nhập',
    signInTitle: 'Chào bạn trở lại.',
    signInLede: 'Đơn hàng, số dư và mọi thứ còn đang chạy vẫn ở nguyên chỗ cũ.',
    identifier: 'Tên đăng nhập hoặc email',
    password: 'Mật khẩu',
    passwordPlaceholder: 'Mật khẩu của bạn',
    passkey: 'Đăng nhập bằng passkey',
    or: 'hoặc',
    forgot: 'Quên mật khẩu?',
    remember: 'Giữ đăng nhập trong 30 ngày',
    newHere: 'Bạn mới đến?',
    createAccount: 'Tạo tài khoản',
    show: 'Hiện',
    hide: 'Ẩn',

    registerKey: 'Tạo tài khoản',
    registerTitle: 'Đặt đơn trong chưa đầy một phút.',
    registerLede: 'Chỉ cần tên đăng nhập và mật khẩu.',
    registerCarries: 'Dịch vụ bạn chọn đang đợi ở phía bên kia.',
    registerClosed: 'Hiện đang tạm ngừng đăng ký. Vui lòng quay lại sau.',
    username: 'Tên đăng nhập',
    usernameHint: 'Chữ cái, chữ số, dấu chấm, gạch ngang và gạch dưới.',
    newPassword: 'Mật khẩu',
    newPasswordPlaceholder: 'Ít nhất 10 ký tự',
    noEmailTitle: 'Không cần email để bắt đầu',
    noEmailBody:
      'Bạn có thể thêm email khi thanh toán. Chừng nào chưa có, chúng tôi không khôi phục được tài khoản, nên tài khoản không có email sẽ bị xoá sau 5 ngày. Thêm email sẽ giữ tài khoản lại — và những gì bạn đã trả tiền thì không bao giờ bị xoá tự động.',
    agreeA: 'Tôi đồng ý với',
    terms: 'Điều khoản dịch vụ',
    agreeB: 'và',
    privacy: 'Chính sách bảo mật',
    haveAccount: 'Đã có tài khoản?',

    caseKey: 'Cách đặt đơn ở đây',
    caseTitle: 'Tăng trưởng bạn nhìn thấy được.',
    caseNoEmailTitle: 'Không cần email để bắt đầu',
    caseNoEmailBody:
      'Chỉ cần tên đăng nhập và mật khẩu. Bạn có thể thêm email khi thanh toán, nơi nó là biên nhận chứ không phải rào chắn.',
    casePricedTitle: 'Tính giá trước khi bạn xác nhận',
    casePricedBody:
      'Mọi tổng đều được tính trên máy chủ của chúng tôi và hiện đầy đủ. Con số bạn duyệt là con số bị trừ.',
    caseSettledTitle: 'Tự hoàn tiền hoặc bù hao',
    caseSettledBody:
      'Giao thiếu sẽ quay về ví của bạn mà không cần mở phiếu. Sụt giảm trong thời hạn bù hao thì chúng tôi gửi yêu cầu bù thay bạn.',
    backToSite: 'Quay lại trang chính',
  },

  upsell: {
    title: 'Làm cho trông tự nhiên',
    sameLink: 'Mọi thứ ở đây được giao tới cùng liên kết với đơn phía trên.',
    why: {
      likesForPlays: 'Lượt nghe đi kèm lượt thích là cách một bài hát trông như đang lên.',
      likesForViews:
        'Video có lượt xem mà không có lượt thích trông như mua. Lượt thích bằng vài phần trăm lượt xem trông như có người đã xem thật.',
      viewsForLikes:
        'Lượt thích mà không có lượt xem là điều lạ: không ai thích một video chưa xem, và với video mới, tỷ lệ này lộ rõ.',
      subsForViews:
        'Trong mỗi nghìn người xem có vài người theo dõi. Lượt xem không kéo theo ai trông như con số, không phải khán giả.',
      likesForFollowers:
        'Người theo dõi mới mà không thích gì thì dễ nhận ra. Vài lượt thích trên bài gần đây khiến tăng trưởng trông như người thật.',
      viewsForSubs:
        'Người đăng ký đến từ những video đã được xem. Lượt xem trên video mới nhất khiến người đăng ký mới hợp lý.',
      likesForSubs: 'Người đăng ký thường đã thích một thứ gì đó trước.',
      followersForPlays: 'Lượt nghe từ người nghe rồi theo dõi là cách một bài hát trông như đang lên.',
      likesForComments: 'Bình luận nhiều hơn lượt thích là dấu hiệu lạ. Đa số người bình luận cũng thích.',
      likesForShares: 'Chia sẻ mà không thích hiếm khi xảy ra; lượt thích làm chia sẻ đáng tin.',
      viewsForReactions:
        'Cảm xúc trên bài ít người thấy sẽ nổi bật. Có lượt xem trước, cảm xúc mới trông thật.',
    },
  },

  guest: {
    orderWithout: 'Đặt đơn không cần tài khoản',
    orderTitle: 'Đặt đơn với tư cách khách',
    orderLede:
      'Thanh toán, và đơn được đặt. Email biên nhận có liên kết một lần nhấp để tạo tài khoản đã chứa sẵn đơn này.',
    email: 'Email nhận biên nhận',
    emailHint: 'Chi tiết đơn và liên kết tạo tài khoản sẽ gửi đến đây. Không gửi gì khác.',
    linkLabel: 'Liên kết hoặc tên người dùng',
    linkHint: 'Liên kết đến hồ sơ hoặc bài đăng công khai. Không giao được cho tài khoản riêng tư.',
    payWith: 'Thanh toán bằng',
    noMethods: 'Thanh toán đang được thiết lập. Đăng nhập để đặt đơn từ số dư.',
    pay: 'Thanh toán {amount}',
    methods: {
      xenditPhLabel: 'GCash, Maya và chuyển khoản',
      xenditPh: 'GCash, Maya, GrabPay và chuyển khoản',
      xenditId: 'OVO, DANA, chuyển khoản và điểm bán lẻ',
      local: 'Thanh toán bằng {currency} · không quy đổi',
    },
    feeNote: 'Đã gồm phí xử lý {method} {fee}, để đơn được thanh toán đủ.',
    minimumNote:
      'Mức tối thiểu của phương thức này là {amount}; phần chênh giữ lại làm số dư trong tài khoản của bạn.',
    basket: 'Giỏ hàng',
    haveAccount: 'Đã có tài khoản?',
    status: {
      eyebrow: 'Đơn của bạn',
      waitingTitle: 'Đang xác nhận thanh toán.',
      waitingLede:
        'Cổng thanh toán đang báo cho chúng tôi là đã xong. Thường mất vài giây; trang tự cập nhật.',
      placedTitle: 'Đơn của bạn đã được đặt.',
      placedLede:
        'Việc giao tự bắt đầu. Biên nhận đang được gửi tới email của bạn, kèm liên kết biến đây thành tài khoản của bạn.',
      failedTitle: 'Thanh toán chưa hoàn tất.',
      failedLede: 'Không có gì bị trừ và không đơn nào được đặt. Bạn có thể bắt đầu lại bất cứ lúc nào.',
      canceledLede: 'Thanh toán đã bị huỷ trước khi hoàn tất. Không có gì bị trừ.',
      reference: 'Mã tham chiếu',
      paid: 'Đã thanh toán',
      email: 'Biên nhận gửi tới',
      polling: 'Đang chờ cổng thanh toán…',
      failedItems:
        '{count} mục không đặt được. Tiền được giữ làm số dư trong tài khoản của bạn; email sẽ giải thích.',
      nextKey: 'Tiếp theo',
      nextBody:
        'Mở email và nhấp "Create my account". Bạn chọn tên đăng nhập và mật khẩu, và các đơn này hiện lên màn hình — theo dõi giao trực tiếp, bù hao và hoàn tiền được lo sẵn. Liên kết có hiệu lực 30 ngày.',
      help: 'Trung tâm trợ giúp',
      tryAgain: 'Thử lại',
      notFound: 'Chúng tôi không tìm thấy thanh toán đó.',
    },
    claim: {
      key: 'Tạo tài khoản của bạn',
      loading: 'Chờ một chút…',
      title: 'Chọn tên đăng nhập và mật khẩu.',
      lede: 'Chỉ vậy thôi. {count} đơn đã thanh toán của bạn đã nằm trong tài khoản này.',
      emailConfirmed: '{email} đã được xác nhận — bạn đã nhấp liên kết chúng tôi gửi tới đó.',
      submit: 'Tạo tài khoản và xem đơn',
      invalidTitle: 'Liên kết này đã hết hạn.',
      invalidLede:
        'Liên kết nhận tài khoản có hiệu lực 30 ngày. Nếu đã tạo tài khoản, hãy đăng nhập; nếu chưa, hỏi trung tâm trợ giúp và nêu số đơn.',
    },
  },

  footer: {
    tagline: 'Tăng trưởng bạn nhìn thấy được.',
    blurb:
      'Xem các dịch vụ mạng xã hội với giá rõ ràng và theo dõi đơn hàng. Thời gian giao dự kiến, bảo hành bù hao và điều kiện hoàn tiền tùy theo từng dịch vụ.',
    startKey: 'Bắt đầu trong chưa đầy một phút',
    createAccount: 'Tạo tài khoản',
    getHelp: 'Nhận trợ giúp',
    startNote:
      'Chỉ cần tên đăng nhập và mật khẩu. Hỗ trợ chạy qua phiếu, đã gắn sẵn với tài khoản và đơn hàng của bạn.',
    product: 'Sản phẩm',
    help: 'Trợ giúp',
    legal: 'Pháp lý',
    platforms: 'Nền tảng',
    pricing: 'Bảng giá',
    signIn: 'Đăng nhập',
    helpCentre: 'Trung tâm trợ giúp',
    terms: 'Điều khoản dịch vụ',
    privacy: 'Chính sách bảo mật',
    rights: '© {year} {site}. Bảo lưu mọi quyền.',
    mono: 'Giá theo 1.000 · kiểm tra tổng tiền trước khi thanh toán',
    notAffiliated: 'Không liên kết với bất kỳ nền tảng mạng xã hội nào.',
    top: 'Lên đầu',
  },

  faq: {
    eyebrow: 'Trung tâm trợ giúp',
    titleA: 'Những điều đáng hỏi',
    titleEm: 'trước khi',
    titleB: 'bạn trả tiền',
    lede: 'Kể cả những câu có câu trả lời khó nghe. Nếu không có ở đây, cứ hỏi. Danh sách này lớn lên từ những gì mọi người thực sự hỏi.',
    searchPlaceholder: 'Tìm trong {count} câu hỏi',
    searchLabel: 'Tìm câu hỏi',
    clearSearch: 'Xóa tìm kiếm',
    try: 'Thử',
    suggestions: 'hoàn tiền, mật khẩu, GCash, hủy, tụt',
    topics: 'Chủ đề',
    ofTotal: 'trên {total}',
    inTopic: 'trong {topic}',
    matching: 'khớp với “{query}”',
    showAll: 'Hiện tất cả',
    emptyTitle: 'Không có gì khớp với “{query}”.',
    emptyText: 'Thử từ khác, hoặc hỏi trực tiếp. Một câu hỏi chưa có lời đáp là cách danh sách này dài thêm.',
    previous: 'Trước',
    next: 'Tiếp',
    stillUnsure: 'Vẫn chưa rõ? Mở ticket',
    contactKey: 'Vẫn bí?',
    contactTitle: 'Hỏi những người vận hành hệ thống',
    contactText:
      'Hỗ trợ đi qua ticket trong bảng điều khiển, không qua hộp thư. Ticket đến đúng những người đó, và đã gắn sẵn với tài khoản cùng đơn hàng của bạn, nên không ai phải hỏi bạn số đơn.',
    contactNote: 'Chưa có tài khoản? Tạo một cái chỉ cần tên đăng nhập và mật khẩu, mất khoảng ba mươi giây.',
    openTicket: 'Mở ticket',
    createAccount: 'Tạo tài khoản',
    groups: {
      quality: { label: 'Chất lượng và tụt', blurb: 'Có giữ được không, và chúng tôi làm gì khi không.' },
      orders: { label: 'Đơn hàng', blurb: 'Tốc độ, liên kết, giao thiếu và hủy.' },
      money: { label: 'Thanh toán', blurb: 'Cách trả, giá theo khu vực và wallet của bạn.' },
      account: {
        label: 'Tài khoản và an toàn',
        blurb: 'Mật khẩu, rủi ro nền tảng, đăng ký, dữ liệu của bạn.',
      },
    },
    q: {
      retention: {
        q: 'Follower có giữ được không, hay sẽ biến mất?',
        a1: 'Có tụt. Ai nói khác là đang bán cho bạn thứ gì đó: tài khoản bị xóa, người ta bỏ theo dõi, và các nền tảng gỡ tương tác không thật theo từng đợt.',
        a2: 'Điểm khác ở đây là chúng tôi đo nó. Mọi đơn hoàn tất được kiểm tra lại sau 1, 7 và 30 ngày, so số đã giao với số lúc hoàn tất. Khi đủ dữ liệu, tỷ lệ giữ được in trên form đặt hàng ngay cạnh giá, cùng số đơn đã đo.',
        a3: 'Chúng tôi công bố con số đó kể cả khi nó tệ. Dịch vụ giữ 78% thì hiện 78%.',
      },
      refill: {
        q: 'Nếu đơn của tôi bị tụt thì sao?',
        a1: 'Với dịch vụ có bảo hành bù hao, chúng tôi tự gửi yêu cầu bù. Bạn không cần để ý, không cần hỏi. Chính phép đo tạo ra tỷ lệ giữ sẽ kích hoạt việc bù.',
        a2: 'Đây là lời phàn nàn phổ biến nhất trong ngành: bán bảo hành bù hao rồi lặng lẽ lờ đi khi có người muốn dùng. Bỏ bước phải xin chính là mục đích.',
      },
      qualityVsPrice: {
        q: 'Sao bạn không phải nơi rẻ nhất?',
        a1: 'Vì nơi rẻ nhất thường không rẻ nhất. Một nghìn follower giá thấp hơn nhưng mất một phần ba sẽ đắt hơn tính trên mỗi follower bạn thực sự giữ, so với nơi đắt hơn nhưng giữ được.',
        a2: 'Chúng tôi định tuyến mọi đơn theo giá trên mỗi follower còn lại, không theo giá niêm yết, và cùng logic đó quyết định mức chúng tôi thu. Đôi khi điều đó khiến chúng tôi rẻ nhất; khi không, phần chênh là để mua sự giao hàng giữ được.',
      },
      speed: {
        q: 'Đơn bắt đầu nhanh cỡ nào?',
        a1: 'Hầu hết dịch vụ bắt đầu trong vài phút. Mỗi dịch vụ hiện thời gian bắt đầu và tốc độ điển hình của chính nó trên form đặt hàng, lấy từ những gì dịch vụ đó thực sự đã làm chứ không từ lời hứa.',
        a2: 'Đơn chưa nhúc nhích hiện trong danh sách đơn của bạn với trạng thái trực tiếp, và bạn nhận email khi nó xong.',
      },
      partial: {
        q: 'Nếu đơn chỉ được giao một phần thì sao?',
        a1: 'Bạn được hoàn tự động phần chưa giao, theo đúng giá đã trả, và tiền về wallet mà bạn không cần hỏi. Đơn thất bại hoàn toàn được hoàn đủ theo cùng cách.',
        a2: 'Hoàn tiền được tính từ đơn hàng và ghi vào ledger bởi hệ thống, không phải bởi một người quyết định có chấp nhận hay không.',
      },
      cancel: {
        q: 'Tôi có thể hủy đơn không?',
        a1: 'Với dịch vụ hỗ trợ hủy, có. Tùy chọn hiện ngay trên đơn. Nhiều dịch vụ không thể hủy khi đã bắt đầu giao, và form đặt hàng nói rõ dịch vụ nào trước khi bạn mua, không phải sau.',
      },
      link: {
        q: 'Tôi nên đưa liên kết nào?',
        a1: 'Đúng thứ dịch vụ yêu cầu: URL hồ sơ cho follower, URL bài đăng cho lượt thích hoặc lượt xem, đôi khi chỉ là tên người dùng. Ô nhập cho biết cần gì và từ chối định dạng sai trước khi bạn trả tiền, thay vì thất bại sau đó.',
        a2: 'Tài khoản của bạn phải ở chế độ công khai trong suốt thời gian đơn chạy. Tài khoản riêng tư không nhận được giao hàng, và bù hao không sửa được điều đó.',
      },
      payment: {
        q: 'Tôi thanh toán bằng cách nào?',
        a1: 'Thẻ, và các phương thức thanh toán nội địa nơi chúng tôi hỗ trợ. Ở Philippines là GCash, Maya và GrabPay.',
        a2: 'Tiền vào số dư wallet trước, đơn hàng trừ từ đó. Nghĩa là đơn không bao giờ phải chờ thanh toán được xử lý, và hoàn tiền về ngay thay vì gửi ngược qua mạng thẻ.',
      },
      regional: {
        q: 'Sao một số nước có giá thấp hơn?',
        a1: 'Vì mức giá hợp lý ở London không hợp lý ở Manila. Khách trả tiền từ một nước được hỗ trợ nhận bảng giá nội địa.',
        a2: 'Nó đến từ phương thức thanh toán, không phải từ nơi bạn có vẻ đang duyệt web: ví điện tử nội địa hoặc thẻ phát hành tại nước đó. Công bằng hơn so với dò vị trí, thứ dễ giả và sẽ chặn nhầm người làm việc ở nước ngoài mua cho gia đình ở quê.',
      },
      refundWallet: {
        q: 'Tôi có thể rút số dư wallet không?',
        a1: 'Tiền trong wallet dành cho đơn hàng và không rút được. Nạp đúng số bạn định dùng thay vì để tiền nằm đó.',
        a2: 'Mọi khoản hoàn từ đơn thất bại hoặc giao thiếu quay về wallet và có thể dùng cho bất kỳ thứ gì khác.',
      },
      password: {
        q: 'Bạn có cần mật khẩu của tôi không?',
        a1: 'Không. Không bao giờ. Chúng tôi chỉ hỏi liên kết công khai hoặc tên người dùng, không gì khác.',
        a2: 'Bất kỳ dịch vụ nào ở đâu hỏi mật khẩu mạng xã hội của bạn là đang xâm phạm tài khoản bạn hoặc sắp làm vậy. Không có lý do chính đáng nào cho việc đó.',
      },
      safe: {
        q: 'Điều này có an toàn cho tài khoản của tôi không?',
        a1: 'Chúng tôi không bao giờ chạm vào đăng nhập của bạn, và việc giao diễn ra từ bên ngoài tài khoản. Lưu ý thẳng thắn: mua tương tác trái với điều khoản dịch vụ của mọi nền tảng lớn, và việc thực thi là của họ, không phải của chúng tôi.',
        a2: 'Thực tế: giữ đơn hàng tương xứng với quy mô tài khoản, tránh đặt cùng một thứ lặp lại trong thời gian ngắn, và coi bất cứ gì trông đột ngột là rủi ro. Tăng chậm thì trông như tăng chậm.',
      },
      signup: {
        q: 'Sao tôi có thể đăng ký mà không cần email?',
        a1: 'Để bạn đặt đơn trong chưa đầy một phút. Tên đăng nhập và mật khẩu là đủ để bắt đầu.',
        a2: 'Đánh đổi là thật và chúng tôi nói trước: không có email, chúng tôi không thể khôi phục tài khoản hay gửi biên lai, nên tài khoản không có email bị xóa sau 5 ngày. Thêm email bất cứ lúc nào sẽ giữ lại nó. Tài khoản có số dư, đơn hàng hoặc thanh toán không bao giờ bị xóa tự động, mà được chuyển cho người xem xét.',
      },
      privacy: {
        q: 'Bạn làm gì với dữ liệu của tôi?',
        a1: 'Chúng tôi giữ những gì cần để chạy đơn của bạn và không hơn. Chúng tôi không bán nó, và không đăng gì ở đâu cả.',
        a2: 'Chi tiết đầy đủ nằm trong chính sách bảo mật, được viết để đọc chứ không phải để chịu đựng.',
      },
    },
  },

  help: {
    key: 'Trung tâm trợ giúp',
    title: 'Hỏi những người vận hành hệ thống.',
    lede: 'Ở đây không có hộp thư. Mọi thứ trở thành ticket trong một hàng đợi duy nhất mà nhân viên của chúng tôi làm việc, và bạn không bao giờ cần email để được giúp, hay để đọc câu trả lời.',
    points: {
      findTitle: 'Bị khóa ngoài? Tìm đơn của bạn',
      findBody:
        'Số đơn, tên đăng nhập của tài khoản, và bốn ký tự cuối của một mã tham chiếu thanh toán chứng minh đơn là của bạn. Sau đó bạn thấy chính xác chuyện gì đang xảy ra với nó.',
      autoTitle: 'Hầu hết câu trả lời không cần đến người',
      autoBody:
        'Giao thiếu tự hoàn tiền, tụt tự bù hao, và trang đơn hàng cho biết điều nào đã xảy ra. Khi thực sự cần người, chuyển giao ngay từ màn hình đó.',
      repliesTitle: 'Phản hồi nằm trên ticket',
      repliesBody:
        'Đã đăng nhập thì ở mục Hỗ trợ. Chưa đăng nhập thì ở trang mở bằng số và khóa. Không gì gửi qua email, và chúng tôi không bao giờ hỏi mật khẩu mạng xã hội.',
    },
    asideGuest: 'Có tài khoản và nhớ mật khẩu? {link} và ticket được lưu dưới mục Hỗ trợ cho bạn.',
    asideGuestLink: 'Đăng nhập',
    asideUser: 'Ticket của bạn nằm ở {link}, ngay cạnh đơn hàng.',
    asideUserLink: 'Hỗ trợ',
    laneOrder: 'Tìm đơn của tôi',
    laneTicket: 'Mở ticket',

    findFailed: 'Chúng tôi không khớp được những thông tin đó với đơn hàng nào.',
    refreshFailed: 'Không làm mới được đơn hàng',
    orderNumber: 'Số đơn',
    orderNumberPlaceholder: 'vd. 1042',
    orderNumberHint: 'Hiện trên trang đơn hàng và trong xác nhận.',
    username: 'Tên đăng nhập của tài khoản',
    usernamePlaceholder: 'tencuaban',
    last4: 'Bốn ký tự cuối của mã tham chiếu thanh toán',
    last4Placeholder: 'vd. 9QX2',
    last4Hint:
      'Bất kỳ lần nạp thành công nào trên tài khoản. Mã tham chiếu trông như PAY-7F3K9QX2 trên trang wallet và biên lai.',
    findOrder: 'Tìm đơn hàng',
    findFoot:
      'Không có mã thanh toán trong tay? Mở ticket thay vào đó và cho số đơn; sẽ có người xác minh cùng bạn.',

    status: {
      PENDING: 'Đang xếp hàng',
      QUEUED: 'Đang xếp hàng',
      SUBMITTING: 'Đang gửi',
      PROCESSING: 'Đang xử lý',
      IN_PROGRESS: 'Đang giao',
      PARTIAL: 'Giao một phần',
      COMPLETED: 'Hoàn tất',
      CANCELED: 'Đã hủy',
      FAILED: 'Thất bại',
      REFUNDED: 'Đã hoàn tiền',
    },
    orderKey: 'Đơn #{number}',
    orderMeta: '{platform} · đặt {quantity} · {charge} · đặt lúc {date}',
    done: 'Xong',
    providerNote: 'Ghi chú nhà cung cấp: {note}',
    refundedToWallet: 'Đã hoàn vào wallet',
    checkAfter: 'Kiểm tra sau {n} ngày',
    stillThere: 'còn {held}%',
    due: 'đến hạn {date}',
    refillAt: 'Bù hao {date}',
    ticketNumber: 'Ticket #{number}',

    escalatedTitle: 'Ticket #{number} đã đến tay nhân viên.',
    escalatedBody:
      'Nó được lưu dưới đơn này và dưới tài khoản. Liên kết này mở nó trong lúc bạn bị khóa ngoài; đây là bản sao duy nhất của khóa.',
    copy: 'Sao chép',
    copied: 'Đã chép',
    copyLink: 'Sao chép liên kết',
    openTheTicket: 'Mở ticket',
    needPersonTitle: 'Vẫn cần người?',
    needPersonBody: 'Chuyển đơn này cho bộ phận hỗ trợ. Họ thấy mọi thứ ở trên, cộng thêm phía nhà cung cấp.',
    escalate: 'Chuyển cho nhân viên',
    escalateLabel: 'Họ nên biết gì?',
    escalatePlaceholder:
      'Điều bạn mong đợi, điều bạn thấy, và bất cứ gì các con số ở trên không giải thích được.',
    reachYou: 'Cách liên hệ bạn',
    reachYouEscPlaceholder: 'Tùy chọn: một tài khoản mạng xã hội. Phản hồi vẫn hiện trên ticket.',
    escalateFailed: 'Không mở được ticket',

    emailAttached: 'Đã gắn email.',
    noEmailTitle: 'Tài khoản này chưa có email.',
    noEmailBody:
      'Gắn một email và mật khẩu có thể được đặt lại theo cách thông thường. Email chỉ dùng cho việc đó và biên lai.',
    attachEmail: 'Gắn email',
    emailLabel: 'Email cho tài khoản này',
    emailPlaceholder: "ban{'@'}example.com",
    attachSend: 'Gắn và gửi xác minh',
    attachFailed: 'Không gắn được email đó',
    viewStays: 'Trang này mở trong 30 phút.',
    refreshOrder: 'Làm mới đơn hàng',

    yourTickets: 'Ticket đang mở của bạn',
    ticketOpened: 'Đã mở ticket',
    queuedTitle: 'Bạn là {number} trong hàng đợi.',
    queuedToast: '#{number} đã vào hàng đợi.',
    sentLede:
      'Nhân viên đã được báo. Liên kết này mở ticket của bạn, hiện mọi phản hồi, và cho bạn trả lời. Đây là bản sao duy nhất của khóa, hãy cất ở nơi an toàn.',
    sendAnother: 'Gửi cái khác',
    sentNote:
      'Trình duyệt này cũng nhớ khóa, nên quay lại trang ticket từ đây sẽ hoạt động mà không cần liên kết.',
    yourName: 'Tên của bạn',
    yourNamePlaceholder: 'Chúng tôi nên gọi bạn là gì?',
    reachYouPlaceholder: 'Tùy chọn: một tài khoản mạng xã hội, hoặc tên đăng nhập của bạn ở đây',
    reachYouHint: 'Chỉ nếu bạn muốn. Phản hồi vẫn hiện trên ticket.',
    about: 'Vấn đề này về',
    topic: 'Chủ đề',
    topics: {
      ORDER: 'Một đơn hàng',
      PAYMENT: 'Một thanh toán',
      ACCOUNT: 'Tài khoản của tôi',
      REFILL: 'Một lần bù hao',
      OTHER: 'Việc khác',
    },
    subject: 'Tiêu đề',
    subjectPlaceholder: 'Một dòng về vấn đề này',
    message: 'Nội dung',
    messagePlaceholder:
      'Chuyện gì đã xảy ra, bạn mong đợi gì, và bất cứ gì giúp chúng tôi tìm ra: số đơn, liên kết, thời gian.',
    messageHint: 'Số đơn và liên kết giúp ích. Mật khẩu thì không bao giờ, chúng tôi sẽ không hỏi.',
    submitGuest: 'Mở ticket',
    submitUser: 'Mở ticket dưới tài khoản của tôi',
    sendFailed: 'Không gửi được tin nhắn của bạn',
    faqFoot:
      'Muốn tìm câu trả lời trước? {link} bao gồm những câu mọi người thực sự hỏi, kể cả câu trả lời khó nghe.',
    faqFootLink: 'Câu hỏi thường gặp',
  },

  ticket: {
    number: 'Ticket #{number}',
    opening: 'Đang mở…',
    needsKey: 'Ticket này cần khóa của nó.',
    wrongKey: 'Khóa đó không mở được ticket này.',
    needsKeyBody: 'Liên kết bạn nhận khi mở ticket có chứa khóa. Dán khóa từ liên kết đó vào bên dưới.',
    mismatch: 'Số ticket và khóa không khớp.',
    keyLabel: 'Khóa',
    keyPlaceholder: 'Dán khóa từ liên kết của bạn',
    openTicket: 'Mở ticket',
    lostKey: 'Mất khóa? Không thể khôi phục. {link} và nhắc đến #{number} để chúng tôi gộp hai ticket.',
    lostKeyLink: 'Mở ticket mới',
    status: {
      OPEN: 'Đang mở',
      PENDING_SUPPORT: 'Chờ hỗ trợ',
      PENDING_CUSTOMER: 'Chờ bạn',
      RESOLVED: 'Đã giải quyết',
      CLOSED: 'Đã đóng',
    },
    opened: 'Mở lúc {date}',
    with: 'với {name}',
    staff: '{name} · Hỗ trợ',
    you: 'Bạn',
    reply: 'Trả lời',
    replyPlaceholder: 'Thêm bất cứ gì giúp ích, hoặc trả lời câu hỏi từ bộ phận hỗ trợ.',
    repliesHere: 'Phản hồi hiện ở đây; không gì gửi qua email.',
    sendReply: 'Gửi trả lời',
    sendFailed: 'Không gửi được trả lời của bạn',
    closed: 'Ticket này đã đóng. Nếu vẫn có vấn đề, {link} và nhắc đến #{number}.',
    closedLink: 'mở ticket mới',
  },

  legal: {
    updated: 'Cập nhật {date}',
    sections: '{n} mục',
    minRead: 'đọc {n} phút',
    contents: 'Mục lục',
    plainWords: 'Nói đơn giản',
    keepReading: 'Đọc tiếp',
    backToTop: 'Về đầu trang',
  },
}
